var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: "24px",
    viewBox: "0 -960 960 960",
    width: "24px",
    fill: "#e8eaed",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M403.23-148.08 188.08-363.23l215.46-215.46 39.23 40.04-147.35 147.34h380.54v-380.61h55.96v436.57h-436.5l147.85 147.23-40.04 40.04Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowSvg);
export default __webpack_public_path__ + "static/media/arrow_svg.dce1c592b90bd23cffd5430e33b957b2.svg";
export { ForwardRef as ReactComponent };